// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-lock {
  position: fixed;
  inset: 0;
  z-index: 100000;
  background: var(--ion-background-color, #ffffff);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  padding: 24px;
  padding-top: calc(24px + env(safe-area-inset-top, 0));
  padding-bottom: calc(24px + env(safe-area-inset-bottom, 0));
}

.app-lock__logo {
  width: 88px;
  height: 88px;
  margin-bottom: 8px;
}

.app-lock__title {
  margin: 0;
  font-weight: 700;
}

.app-lock__subtitle {
  margin: 0 0 16px;
  opacity: 0.7;
}

.app-lock__unlock {
  width: 100%;
  max-width: 320px;
}

.app-lock__logout {
  --color: var(--rsm-brand);
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-lock/app-lock.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,eAAA;EACA,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,qDAAA;EACA,2DAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".app-lock {\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  background: var(--ion-background-color, #ffffff);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 12px;\n  padding: 24px;\n  padding-top: calc(24px + env(safe-area-inset-top, 0));\n  padding-bottom: calc(24px + env(safe-area-inset-bottom, 0));\n}\n\n.app-lock__logo {\n  width: 88px;\n  height: 88px;\n  margin-bottom: 8px;\n}\n\n.app-lock__title {\n  margin: 0;\n  font-weight: 700;\n}\n\n.app-lock__subtitle {\n  margin: 0 0 16px;\n  opacity: 0.7;\n}\n\n.app-lock__unlock {\n  width: 100%;\n  max-width: 320px;\n}\n\n.app-lock__logout {\n  --color: var(--rsm-brand);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
